import React from "react";
import { Grid, Typography, TextField, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';

const StabilityForm = ({
  stabilitySettings: ss,
  onChangeHandler,
  inputSelected,
}) => {
  return (
    <>
      <Grid container spacing={2} sx={{ p: 2, alignItems: "center" }}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Travelling Time</Typography>
          <Grid container spacing={2} sx={{ alignItems: "center" }}>
            <Grid size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" sx={{ textAlign: "center", mb: 0.5 }}>START</Typography>
              <TextField
                size="small"
                fullWidth
                value={ss?.startDelay ?? ""}
                onChange={(e) => onChangeHandler("startDelay", e.target.value)}
                onClick={(e) => inputSelected(e, "startDelay")}
              />
              <Typography variant="caption" sx={{ textAlign: "center", display: "block" }}>Seconds</Typography>
            </Grid>
            <Grid size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" sx={{ textAlign: "center", mb: 0.5 }}>END</Typography>
              <TextField
                size="small"
                fullWidth
                value={ss?.endDelay ?? "0"}
                onChange={(e) => onChangeHandler("endDelay", e.target.value)}
                onClick={(e) => inputSelected(e, "endDelay")}
              />
              <Typography variant="caption" sx={{ textAlign: "center", display: "block" }}>Seconds</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>Time Window</Typography>
          <Grid container spacing={2}>
            <Grid size={{ xs: 6, sm: 4 }}>
              <TextField
                size="small"
                fullWidth
                value={ss?.window ?? ""}
                onChange={(e) => onChangeHandler("window", e.target.value)}
                onClick={(e) => inputSelected(e, "window")}
              />
              <Typography variant="caption" sx={{ textAlign: "center", display: "block" }}>Seconds</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Table size="small" sx={{ m: 2 }}>
        <TableHead>
          <TableRow>
            <TableCell />
            {ss.components && ss.components.map((comp, idx) => (
              <TableCell key={idx} align="center">{comp.name}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Zero</TableCell>
            {ss.components && ss.components.map((comp, idx) => (
              <TableCell key={`zero_${idx}`} align="center">
                <TextField
                  size="small"
                  value={comp.zeroTolerance ?? ""}
                  onChange={(e) => onChangeHandler("zeroTolerance", e.target.value, comp.name)}
                  onClick={(e) => inputSelected(e, comp.name + "|zeroTolerance")}
                  error={comp.zeroTolerance !== "" && comp.zeroTolerance != null && isNaN(Number(String(comp.zeroTolerance).replace(",", ".")))}
                  helperText={comp.zeroTolerance !== "" && comp.zeroTolerance != null && isNaN(Number(String(comp.zeroTolerance).replace(",", "."))) ? "Input a number" : ""}
                  sx={{ width: 100 }}
                />
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            <TableCell>Span</TableCell>
            {ss.components && ss.components.map((comp, idx) => (
              <TableCell key={`span_${idx}`} align="center">
                <TextField
                  size="small"
                  value={comp.spanTolerance ?? ""}
                  onChange={(e) => onChangeHandler("spanTolerance", e.target.value, comp.name)}
                  onClick={(e) => inputSelected(e, comp.name + "|spanTolerance")}
                  error={comp.spanTolerance !== "" && comp.spanTolerance != null && isNaN(Number(String(comp.spanTolerance).replace(",", ".")))}
                  helperText={comp.spanTolerance !== "" && comp.spanTolerance != null && isNaN(Number(String(comp.spanTolerance).replace(",", "."))) ? "Input a number" : ""}
                  sx={{ width: 100 }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default StabilityForm;
